import {
  ArrayInput,
  BooleanInput,
  Create,
  ListButton,
  required,
  SaveButton,
  SelectInput,
  SimpleFormIterator,
  TabbedForm,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

const CreateToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Create" />
    <ListButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const CreateActions = () => (
  <TopToolbar sx={{ justifyContent: "flex-start" }}>
    <ListButton />
  </TopToolbar>
);

export const LandingsCreate = () => (
  <Create actions={<CreateActions />} redirect="list">
    <TabbedForm toolbar={<CreateToolbar />}>
      <TabbedForm.Tab label="Landing">
        <TextInput
          source="title"
          label="Landing Title:"
          validate={required()}
        />
        <TextInput
          source="appLandingId"
          label="App Landing ID:"
          validate={required()}
        />
        <BooleanInput
          source="showAcceptPrivacy"
          label="Show Accept Privacy:"
          validate={required()}
        />
      </TabbedForm.Tab>

      <TabbedForm.Tab label="Attributes">
        <ArrayInput source="attributes">
          <SimpleFormIterator inline>
            <SelectInput
              source="groupName"
              label="Group Name:"
              choices={[{ id: "subscription", name: "subscription" }]}
              defaultValue="subscription"
            />
            <TextInput source="content" label="Content:" />
          </SimpleFormIterator>
        </ArrayInput>
      </TabbedForm.Tab>
    </TabbedForm>
  </Create>
);
